import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { AutenticacionService } from './autenticacion.service';
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import { VigenciasSolicitudesRespaldos } from '../_models/vigencias';

@Injectable({
    providedIn: 'root'
})
export class ValiditySupportingService {

  serviceURL = AppSettings.rutServiciosAPL + '/api/vigenciasSolicitudesRespaldos';

  constructor( private authHttp: HttpClient, private authenticationService: AutenticacionService ) {
  }

  getAll() {
     return this.authHttp.get( this.serviceURL ).pipe( map( res => res as VigenciasSolicitudesRespaldos[] ) );
  }

  getAllEnable() {
     return this.authHttp.get( this.serviceURL + '/enabled' ).pipe( map( res => res as VigenciasSolicitudesRespaldos[] ) );
  }

  getById( id: string ) {
     return this.authHttp.get( this.serviceURL + '/' + id  ).pipe( map( res => res as VigenciasSolicitudesRespaldos ) );
  }

  add( c: VigenciasSolicitudesRespaldos ) {
     c.auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
     return this.authHttp.post( this.serviceURL, c ).pipe( map( res => res as VigenciasSolicitudesRespaldos ) );
  }

  update( c: VigenciasSolicitudesRespaldos ) {
     c.auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
     return this.authHttp.put( this.serviceURL , c ).pipe( map( res => res as VigenciasSolicitudesRespaldos ) );
  }

  bulk( c: VigenciasSolicitudesRespaldos[] ) {
    c.forEach( item => {
      item.auditoriaUsuario = this.authenticationService.obtenerIdUsuarioLogueado();
    } );
    return this.authHttp.post( this.serviceURL + '/bulk', c ).pipe( map( res => res as VigenciasSolicitudesRespaldos[] ) );
  }
}
